<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="10">
            <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg"
              type="dark" variant="primary">
              <b-navbar-nav>
                <b-button @click="previousSalesView" size="sm" variant="light">
                  <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
                </b-button>
              </b-navbar-nav>
              <b-navbar-brand center>SHIPPING LINE PAYMENT(INVOICE WISE) CC Import</b-navbar-brand>
            </b-navbar>
          </b-col>
          <b-col md="2">
            <RemoveSlineInvoiceButton v-if="ImportDetail.allModuleId && SBDetail.SlinePayId" :Type="'All'"
              :BTNTitle="''" :SlineType="'Sline'" :TransportType="'Import'" :SlinePayId="SBDetail.SlinePayId" :SlineInvId="''"
              :allModuleId="ImportDetail.allModuleId" @refresh-data="refreshData" />

          </b-col>

        </b-row>

        <banner-component :allModuleIdBanner="ImportDetail.allModuleId ? ImportDetail.allModuleId : ''
          " :jobSeriesBanner="ImportDetail.ccImportSeries ? ImportDetail.ccImportSeries : ''
            " :bannerClientName="ImportDetail.clientName ? ImportDetail.clientName : ''
              " iconId="fa fa-ship" />
        <b-card class="formCard">
          <b-card-text>
            <div>
              <!-- *******************************  Start  WareHouse  Warehouse Stuffing At ICD *****************************-->
              <div class="mt-2" v-if="containerTypeDetailFactoryList.length > 0">
                <h5>
                  <b-badge>Container Details</b-badge>
                </h5>
                <div>
                  <b-button v-if="
                    ContainerTypeSizefactory.ccExecutionContainerId != '' &&
                    showMoreSB == false
                  " size="sm" variant="outline-dark" @click="showMoreSBDet">{{ showMoreSB == true ? "Show" : "Hide "
                    }} Container
                    Details</b-button>
                </div>

                <!-- /.box-header -->

                <b-card class="mt-3" v-if="
                  (getContainerList.length > 0 ||
                    ContainerTypeSizefactory.ccExecutionContainerId != '') &&
                  showMoreSB == false
                " style="background: whiteSmoke">
                  <div class="gutr" v-if="
                    getContainerList.length > 0 ||
                    ContainerTypeSizefactory.ccExecutionContainerId != ''
                  ">
                    <div v-if="showMoreSB == false">
                      <!-- <md-layout md-gutter>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="95">
                            <label>
                              <b>
                                <u>
                                  Container Details
                                  <span
                                    class="error"
                                    v-if="containerTypeDetailFactory.length==0"
                                  >{{errorAtleastContainer}}</span>
                                </u>
                              </b>
                            </label>
                          </md-layout>
                        </md-layout> -->

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="50">
                          <label v-if="
                            ContainerTypeSizefactory.ccExecutionContainerId ==
                            ''
                          ">Container Type/Size</label>
                          <model-list-select v-if="
                            ContainerTypeSizefactory.ccExecutionContainerId ==
                            ''
                          " option-value="containerTypeId" option-text="containerType" :list="ContainerTypeList"
                            placeholder="Select  Type/Size"
                            v-model="ContainerTypeSizefactory.containerTypeId"></model-list-select>
                          <md-layout md-flex="100" v-else>
                            <label for="containerType">Container Type/Size</label>
                            <b-form-input :formatter="capitalizeAll" v-model="ContainerTypeSizefactory.containerType"
                              disabled></b-form-input>
                          </md-layout>
                          <span class="error" v-if="!ContainerTypeSizefactory.containerTypeId">{{
                            errorContainer.containerTypeId }}</span>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="45">
                          <md-layout md-flex="100">
                            <label>Container No.(eg. AAAA1234567)</label>
                            <b-form-input :formatter="capitalizeAll" name="containerNo"
                              v-model="ContainerTypeSizefactory.containerNo"
                              @keyup="containerNoRegexfun"></b-form-input>
                          </md-layout>
                          <span class="error" v-if="!ContainerTypeSizefactory.containerNo">{{ errorContainer.containerNo
                            }}</span>
                          <span class="error" v-else-if="containerNoRegexError != ''">{{ containerNoRegexError }}</span>
                          <span class="error" v-if="
                            containerNoRegexError == '' &&
                            ContainerTypeSizefactory.containerNo != '' &&
                            ContainerTypeSizefactory.containerNo !=
                            algoConNo &&
                            showAlgo == true
                          ">Note:System Generated Container No. is :
                            {{ algoConNo }}</span>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="55"></md-layout>
                        <md-layout md-flex="10">
                          <md-layout md-flex="100">
                            <label>Net Wgt.</label>
                            <b-form-input :formatter="capitalizeAll" id="netWeight" name="netWeight" type="number"
                              min="0" v-model="ContainerTypeSizefactory.netWeight"></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="10">
                          <md-layout md-flex="100">
                            <label>Gross Wgt</label>
                            <b-form-input :formatter="capitalizeAll" id="grossWeight" name="grossWeight" type="number"
                              min="0" v-model="ContainerTypeSizefactory.grossWeight"></b-form-input>
                          </md-layout>

                          <span class="error" v-if="!ContainerTypeSizefactory.grossWeight">{{ errorContainer.grossWeight
                            }}</span>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="15">
                          <label for="weightUnit">Unit</label>
                          <model-list-select :list="unitList" option-value="uV" option-text="uT"
                            placeholder="Select Unit" name="weightUnit" id="weightUnit"
                            v-model="ContainerTypeSizefactory.weightUnit"></model-list-select>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="15">
                          <label>Handover Date</label>
                          <date-picker :format="selectDateFormat" lang="en" :minute-step="1" name="handoverDate"
                            id="handoverDate" v-model="ContainerTypeSizefactory.handoverDate"></date-picker>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Custom Seal No.</label>
                            <b-form-input :formatter="capitalizeAll" id="customSealNo" name="customSealNo"
                              v-model="ContainerTypeSizefactory.customSealNo"></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Line Seal No.</label>
                            <b-form-input :formatter="capitalizeAll" id="LineSealNo" name="LineSealNo"
                              v-model="ContainerTypeSizefactory.LineSealNo"></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>Container Tare Wgt</label>
                            <b-form-input :formatter="capitalizeAll" id="tareWeight" name="tareWeight" type="number"
                              min="0" v-model="ContainerTypeSizefactory.tareWeight"></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>Measurement (in CBM)</label>
                            <b-form-input :formatter="capitalizeAll" name="noOfpkgUnit" id="noOfpkgUnit" type="number"
                              min="0" v-model="ContainerTypeSizefactory.measurement"></b-form-input>
                            <!-- <span
                    class="error"
                    v-if="!ContainerTypeSizefactory.measurement"
                              >{{errorContainer.measurement}}</span>-->
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <label>Package Details</label>
                          <model-list-select :list="packageNameList" id="clientId"
                            v-model="ContainerTypeSizefactory.packageId" option-value="packageId"
                            option-text="packageName" placeholder="Select  Package Name"></model-list-select>

                          <span class="error" v-if="!ContainerTypeSizefactory.packageId">{{ errorContainer.packageId
                            }}</span>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="50">
                          <md-layout md-flex="100">
                            <label>No. of Packages ({{
                              ContainerTypeSizefactory.packageName
                            }})</label>
                            <b-form-input :formatter="capitalizeAll" name="noOfpkgUnit" id="noOfpkgUnit" type="number"
                              min="0" :disabled="ContainerTypeSizefactory.packageName == ''
                                ? true
                                : false
                                " v-model="ContainerTypeSizefactory.noOfpkgUnit"></b-form-input>
                            <span class="error" v-if="!ContainerTypeSizefactory.noOfpkgUnit">{{
                              errorContainer.noOfpkgUnit }}</span>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="20">
                          <label>Cargo Stuffing Date</label>
                          <date-picker :format="selectDateFormat" lang="en" name="cargoStuffingDate"
                            id="cargoStuffingDate" v-model="ContainerTypeSizefactory.cargoStuffingDate"
                            :minute-step="1"></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <label>LEEO (Let Export Permit) Date</label>
                          <date-picker :format="selectDateFormat" lang="en" name="leeoDate" id="leeoDate"
                            v-model="ContainerTypeSizefactory.leeoDate" :minute-step="1"></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="50">
                          <md-layout md-flex="100">
                            <label>LEEO (Let Export Permit) No.</label>
                            <b-form-input :formatter="capitalizeAll" name="leeoNo" id="leeoNo"
                              v-model="ContainerTypeSizefactory.leeoNo"></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                    </div>
                  </div>
                </b-card>

                <div class="box-body mt-2">
                  <table id="ccContainer" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No.</th>

                        <th>Container No.</th>

                        <th>Container Type</th>
                        <th>Custom Seal No.</th>
                        <th>Line Seal No.</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in containerTypeDetailFactoryList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td @click="viewEdit(item.ccExecutionContainerId, index)" class="showMoreData">
                          {{ item.containerNo }}
                        </td>
                        <td @click="viewEdit(item.ccExecutionContainerId, index)" class="showMoreData">
                          {{ item.containerType }}
                        </td>

                        <td>
                          {{
                            item.customSealNo != "" ? item.customSealNo : "--"
                          }}
                        </td>
                        <td>
                          {{ item.LineSealNo != "" ? item.LineSealNo : "--" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.box-body -->
              </div>
              <!-- <div
                class="mt-3"
                v-if="
                  (SBDetail.SlinePayId != '' && accounts == false) ||
                  (SBDetail.SlinePayId != '' && role == 'Admin')
                "
              >
                <b-button
                  id="show-btn"
                  size="sm"
                  variant="outline-primary"
                  @click="showModal"
                >
                  Add Supplementary Invoice</b-button
                >
              </div> -->
              <div class="mt-4" v-if="
                (SBDetail.SlinePayId != '' && accounts == false) ||
                (SBDetail.SlinePayId != '' && role == 'Admin')
              ">
                <!-- checkbox-1 -->
                <input :id="'revcheckbox'" name="checkbox-1" type="checkbox" v-model="SBDetail.revisedMail"
                  @click="RevisedAss('revcheckbox')" value="1" unchecked-value="0" />
                <!-- <b-form-checkbox
                  id="revcheckbox-1"
                  v-model="SBDetail.revisedMail"
                  name="checkbox-1"
                  value="1"
                  unchecked-value="0" @click="RevisedAss('revcheckbox-1')"
                >
                </b-form-checkbox
                > -->
                <span class="error">Send Revised Payment Request</span>
              </div>

              <!-- <md-layout md-gutter class="gutr">
                <div v-if="viewBLDraftDoc.length > 0">
                  <md-layout
                    md-flex="20"
                    v-for="(item, index) in viewBLDraftDoc"
                    :key="index"
                  >
                    <a
                      v-if="ImportDetail.ccImportSeries"
                      :href="
                        `${docURL}/ASSIGNMENT_UPLOADS/` +
                        ImportDetail.ccImportSeries.replaceAll('/', '_') +
                        '/' +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                    <br />
                    <a
                      :href="
                        `${docURL}/CC_Sea_Export_Sline_Payments_Uploads/` +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </div>
                <md-layout md-flex="45"></md-layout>

                <div v-if="viewInvDoc.length > 0">
                  <md-layout
                    md-flex="20"
                    v-for="(item, index) in viewInvDoc"
                    :key="index"
                  >
                    <a
                      v-if="ImportDetail.ccImportSeries"
                      :href="
                        `${docURL}/ASSIGNMENT_UPLOADS/` +
                        ImportDetail.ccImportSeries.replaceAll('/', '_') +
                        '/' +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    ><br />
                    <a
                      :href="
                        `${docURL}/CC_Sea_Export_Sline_Payments_Uploads/` +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </div>
              </md-layout> -->

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>POR<span class="error">*</span></label>
                    <b-form-input :formatter="capitalizeAll" disabled name="POR" id="POR" v-model="POR"></b-form-input>
                    <span class="error" v-if="POR_err ? true : false">{{
                      POR_err
                    }}</span>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>B/L No.<span class="error">*</span></label>
                    <b-form-input :formatter="capitalizeAll" :disabled="(accounts == true && role != 'Admin') ||
                      SBDetail.SlinePayId != ''
                      ? true
                      : false
                      " name="POR" id="POR" v-model="SBDetail.SlineBlNo"></b-form-input>
                    <span class="error" v-if="SBDetail.SlineBlNo_err ? true : false">{{ SBDetail.SlineBlNo_err }}</span>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout style="display: flex; align-items: center">
                  <span>Added By :<span style="font-weight: bold; color: red">{{
                    ImportDetail.username
                  }}</span>
                    on
                    <span style="font-weight: bold; color: red">{{
                      ImportDetail.creationTime
                    }}</span></span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>Shipping Line<span class="error">*</span> </label>
                    <b-form-input :formatter="capitalizeAll" disabled name="POR" id="POR"
                      v-model="ImportDetail.shippingLine"></b-form-input>
                    <span class="error" v-if="ImportDetail.shippingLine_err ? true : false">{{
                      ImportDetail.shippingLine_err }}</span>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Estimated SOB Date <span class="error">*</span></label>
                  <date-picker @input="getDueDate" :disabled="(accounts == true && role != 'Admin') ||
                    SBDetail.SlinePayId != ''
                    ? true
                    : false
                    " lang="en" :format="selectDateFormat" name="sobDate" id="sobDate" v-model="SBDetail.sobDate"
                    :minute-step="1"></date-picker>
                  <span class="error" v-if="SBDetail.sobDate_err ? true : false">{{ SBDetail.sobDate_err }}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <label>Payment Due Date<span class="error">*</span></label>
                  <date-picker :format="selectDateFormat" disabled lang="en" name="sobDate" id="sobDate"
                    v-model="SBDetail.dueDate" :minute-step="1"></date-picker>
                  <span class="error" v-if="SBDetail.dueDate_err ? true : false">{{ SBDetail.dueDate_err }}</span>
                  <!-- <span class="error" v-if="!SBDetail.payDate">{{errorSBExecution.payDate}}</span> -->
                </md-layout>
              </md-layout>

              <hr />

              <div class="my-2">
                <b-row>
                  <b-col cols="6">
                    <multi-file-uploader :disabled="(accounts == true && role != 'Admin') ||
                      SBDetail.SlinePayId != ''
                      ? true
                      : false
                      " :index="0" :second_index="0" :style="`height: 79px;    background: darkgray;    width: 300px;`"
                      :documentName="'CC_Import_SlinePay_BLDraft_'" :otherDocName="'CC_Import_SlinePay_BLDraft_'"
                      :folderName="'BL_DRAFT'" :accept="'*'"
                      :assign_no="ImportDetail.ccImportSeries.replaceAll('/', '_')" :multiple="true"
                      v-model="SBDetail.blDraftUpload" :state="Boolean(SBDetail.blDraftUpload)"
                      :fileAllModuleId="SBDetail.allModuleId"></multi-file-uploader>
                    <a v-if="SBDetail.blDraftUpload && SBDetail.blDraftUpload" href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${ImportDetail.ccImportSeries.replaceAll('/', '_')}/${SBDetail.blDraftUpload}`)">--View</a>
                    <span class="error" v-if="SBDetail.blDraftUpload_err ? true : false">{{ SBDetail.blDraftUpload_err
                      }}</span>
                    <!-- <md-input-container>
                      <label
                        >B/L Draft By Shipping Line<span class="error"
                          >*</span
                        ></label
                      >
                      <md-file
                        :disabled="
                          (accounts == true && role != 'Admin') ||
                          SBDetail.SlinePayId != ''
                            ? true
                            : false
                        "
                        name="invoiceUpload"
                        id="invoiceUpload"
                        v-model="SBDetail.blDraftUpload"
                        @selected="onFileChangeBlDraft('BL_DRAFT', 0)"
                        multiple
                      ></md-file>
                      <span
                        class="error"
                        v-if="SBDetail.blDraftUpload_err ? true : false"
                        >{{ SBDetail.blDraftUpload_err }}</span
                      >
                    </md-input-container> -->
                  </b-col>

                  <b-col md="4" class="ml-5" v-if="FFSeaExportArr.length > 0">
                    <label>FF SEA EXPORT Quotation</label>
                    <table border="1" style="width: 140%; text-align: center;">
                      <thead>
                        <tr>
                          <th>SN</th>
                          <th>Particulars</th>
                          <th>Buying Rate</th>
                          <th>Remark</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in FFSeaExportArr" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <b>{{ item.ffType }}</b>
                          </td>

                          <td>
                            <b>{{ item.buyingRate + " " + item.currency }}</b>
                          </td>

                          <td>
                            <b>{{ item.line_wise_remark }}</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>

                </b-row>
              </div>

              <md-layout md-gutter class="gutr mb-2">
                <!-- <div v-if="viewBLDraftDoc.length > 0">
                  <md-layout
                    md-flex="20"
                    v-for="(item, index) in viewBLDraftDoc"
                    :key="index"
                  >
                    <a
                      v-if="ImportDetail.ccImportSeries"
                      :href="
                        `${docURL}/ASSIGNMENT_UPLOADS/` +
                        ImportDetail.ccImportSeries.replaceAll('/', '_') +
                        '/' +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                    <br />
                    <a
                      :href="`${docURL}/Import_Sline_Payments_Uploads/` + item"
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </div>
                <md-layout md-flex="45"></md-layout> -->

                <!-- <div v-if="viewInvDoc.length > 0">
                  <md-layout
                    md-flex="20"
                    v-for="(item, index) in viewInvDoc"
                    :key="index"
                  >
                    <a
                      v-if="ImportDetail.ccImportSeries"
                      :href="
                        `${docURL}/ASSIGNMENT_UPLOADS/` +
                        ImportDetail.ccImportSeries.replaceAll('/', '_') +
                        '/' +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    ><br />
                    <a
                      :href="
                        `${docURL}/Import_Sline_Payments_Uploads/` +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </div> -->
              </md-layout>

              <b-button v-if="
                accounts != true ||
                $sessionsStorage.get('nameUser') == 'Bhavneesh'
              " id="show-btn" size="sm" variant="outline-primary" @click="addInvArry">
                Add Invoice <i class="fa fa-plus" aria-hidden="true"></i></b-button>
              <b-card class="mt-2" v-for="(itm, idx) in lineInvModalArray" :key="idx">
                <div class="d-flex align-items-center" v-if="idx != 0">
                  <b-button :disabled="itm.SlineInvId != '' ? true : false" class="ml-auto" id="show-btn" size="sm"
                    variant="danger" @click="removeInvArry(idx)">
                    Remove Invoice <i class="fa fa-plus" aria-hidden="true"></i></b-button>
                </div>

                <RemoveSlineInvoiceButton v-if="ImportDetail.allModuleId && SBDetail.SlinePayId"
                  :BTNTitle="'Remove Single Invoice'" :Type="'Single'" :SlineType="'Sline'" :TransportType="'Import'"
                  :SlinePayId="SBDetail.SlinePayId" :SlineInvId="itm.SlineInvId" :allModuleId="ImportDetail.allModuleId"
                  @refresh-data="refreshData" />
                <div class="mt-2" v-if="SBDetail.revisedMail != 0">
                  <!-- <b-form-checkbox
                  id="checkbox-1"
                  v-model="selectedInvoice"
                  :name="`checkbox-${idx}`"
                  @input="addRevisedInvoice(idx)"
                  value="1"
                  unchecked-value="0"
                >
                </b-form-checkbox> -->
                  <input :disabled="itm['invCurrencyList'][0].invPayStatus == 2 ||
                    itm['invCurrencyList'][0].invPayStatus == 1
                    ? true
                    : false
                    " :id="'checkbox-' + idx" type="checkbox" @click="addRevisedInvoice(idx, 'checkbox-' + idx)" />

                  <span class="error">Revise Invoice</span>
                </div>

                <b-row align-v="start">
                  <b-col cols="3">
                    <label>Invoice Category<span class="error">*</span></label>
                    <b-form-radio-group v-model="itm.invCategory" :options="invCategoryList" class="mb-3"
                      value-field="payVal" text-field="payText" disabled-field="notEnabled"></b-form-radio-group>
                    <!-- <model-list-select
                      multiple="true"
                      :isDisabled="
                        (accounts == true && role != 'Admin') ||
                        itm.SlineInvId != ''
                          ? true
                          : false
                      "
                      :list="invCategoryList"
                      v-model="itm.invCategory"
                      option-value="payVal"
                      option-text="payText"
                      placeholder="Select Category"
                    ></model-list-select> -->
                    <span class="error" v-if="itm.invCategory_err ? true : false">{{ itm.invCategory_err }}</span>
                  </b-col>
                  <b-col cols="3"><label>Invoice No<span class="error">*</span></label>
                    <b-form-input :formatter="capitalizeAll" :disabled="(accounts == true && role != 'Admin') ||
                      itm.SlineInvId != ''
                      ? true
                      : false
                      " name="shippingBillNo" id="shippingBillNo" v-model="itm.invNo"></b-form-input>
                    <span class="error" v-if="itm.invNo_err ? true : false">{{
                      itm.invNo_err
                    }}</span></b-col>
                  <b-col cols="6">
                    <label>Invoice Type<span class="error">*</span></label>
                    <!-- <model-list-select
                  multiple="true"
                  :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                      :list="invoiceTypeList"
                      v-model="itm.invType"
                      option-value="value"
                      option-text="text"
                      placeholder="Select Type"
                    ></model-list-select> -->

                    <!-- onSelect(items,lastSelectItem,idx) -->

                    <!-- <multi-select :options="invoiceTypeList"
                       :selected-options="items"
                       placeholder="select Type"
                       
                       @select="(item) => {onSelect(idx, item)}"
                       >
                   </multi-select> -->
                    <multi-select :isDisabled="(accounts == true && role != 'Admin') ||
                      itm.SlineInvId != ''
                      ? true
                      : false
                      " :options="invoiceTypeList" :selected-options="itm.invType" placeholder="select Type"
                      v-model="itm.invType" @select="onSelect($event, $event, itm, idx)" :multiple="true">
                    </multi-select>
                    <span class="error" v-if="itm.invType_err ? true : false">{{
                      itm.invType_err
                    }}</span>
                    <!-- <model-list-select
                      multiple="true"
                      :disabled="
                        accounts == true && role != 'Admin' ? true : false
                      "
                      :list="invoiceTypeList"
                      v-model="itm.invType"
                      option-value="value"
                      option-text="text"
                      placeholder="Select Invoice Type"
                      @select="(item) => {onSelect(idx, item)}"
                    >
                    </model-list-select> -->
                    <!-- @select="(item) => {onSelect(idx,'invoiceType-'+idx,item)}" -->
                    <!-- 
                   <multiselect v-model="items" :options="invoiceTypeList" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="select Type" label="name" track-by="name" :preselect-first="true">
                    
                  </multiselect> -->

                    <!-- <multiselect v-model="items" :options="invoiceTypeList" :searchable="false" :close-on-select="false" :show-labels="false" placeholder="Pick a value"></multiselect> -->
                  </b-col>
                </b-row>

                <b-row align-v="start">
                  <!-- <b-col>
                    <md-input-container>
                      <label>B/L Draft By Shipping Line<span class="error">*</span></label>
                      <md-file
                        :disabled="
                          accounts == true && role != 'Admin' ? true : false
                        "
                        name="invoiceUpload"
                        id="invoiceUpload"
                        v-model="itm.invBlDraftUpload"
                        @selected="onFileChangeBlDraft('BL_DRAFT', idx)"
                        multiple
                      ></md-file> </md-input-container
                  ></b-col> -->
                  <b-col cols="3">
                    <label>Invoice Date<span class="error">*</span></label>
                    <date-picker :format="selectDateFormat" lang="en" name="inv_date" id="inv_date"
                      v-model="itm.inv_date" :minute-step="1" />
                    <span class="error" v-if="itm.inv_date_err ? true : false">{{
                      itm.inv_date_err
                    }}</span>
                  </b-col>
                  <b-col cols="4">
                    <label>Shipping Line Invoice (Drag & Drop)<span class="error">*</span></label>
                    <multi-file-uploader :disabled="(accounts == true && role != 'Admin') || itm.enableDisable == true
                      ? true
                      : false
                      " :index="0" :second_index="idx"
                      :style="`height: 79px;    background: darkgray;    width: 200px;`"
                      :documentName="'CC_Import_SlinePay_SlineInv_'" :otherDocName="'CC_Import_SlinePay_SlineInv_'"
                      :folderName="'Sline_Invoice'" :accept="'*'"
                      :assign_no="ImportDetail.ccImportSeries.replaceAll('/', '_')" :multiple="true"
                      v-model="itm.invSlineUpload" :state="Boolean(itm.invSlineUpload)"
                      :fileAllModuleId="SBDetail.allModuleId"></multi-file-uploader>
                    <span class="error" v-if="itm.invSlineUpload_err ? true : false">{{
                      itm.invSlineUpload_err
                    }}</span>
                    <a v-if="itm.invSlineUpload && itm.invSlineUpload" href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${ImportDetail.ccImportSeries.replaceAll('/', '_')}/${itm.invSlineUpload}`)">--View</a>
                  </b-col>
                  <b-col md="2" class="mb-3">
                    <b-form-radio-group
                      v-model="itm.dispute_status"
                      :options="itm.SlineInvId && itm.dispute_status ? ['Under Dispute', 'Resolved'] : ['Under Dispute']"
                      name="dispute_status"
                      class="mt-4"
                    ></b-form-radio-group>
                  </b-col>
                  <b-col md="3" class="mb-3" v-if="itm.dispute_status">
                    <label class="small text-muted font-weight-bold">Sline Dispute Reason <span class="error">*</span></label>
                    <model-list-select
                      :list="$store.getters['common/getAllRemarkDDList']"
                      v-model="itm.sline_dispute"
                      option-value="label"
                      option-text="label"
                      placeholder="Search & Select SlineDispute"
                      @searchchange="searchSlineDispute"
                      @input="debounceSearch"
                      :isDisabled="itm.dispute_status === 'Resolved'"
                    />
                    <span class="error" v-if="itm.sline_dispute_err ? true : false">{{ itm.sline_dispute_err }}</span>
                  </b-col>
                </b-row>
                <div class="row mt-2">
                  <!-- Supplementary Comment Yes NO Section Start -->
                  <div class="col-md-4 row" v-if="itm.invCategory == 'Supplementary' || itm.dispute_status === 'Resolved'">
                    <label class="col-md-4">Bill to Shipper : <span class="error">*</span></label>
                    <div class="col-md-8">
                      <b-form-radio-group v-model="itm.scCategory" :options="SCCategoryList" class="mb-3"
                        value-field="SCVal" text-field="SCText" @input="
                          chnageSCCategoryList(
                            itm.scCategory,
                            itm.scCategory_err,
                            itm.scremark,
                            itm.scremark_err,
                            lineInvModalArray,
                            idx
                          )
                          "></b-form-radio-group>
                      <span class="error" v-if="
                        (itm.scCategory == '' ||
                          itm.scCategory == null ||
                          itm.scCategory == undefined) &&
                        itm.scCategory_err != ''
                      ">{{ itm.scCategory_err }}</span>
                    </div>
                  </div>
                  <!-- {{itm}} -->
                  <div class="col-md-4 row" v-if="itm.scCategory == 'Yes' || itm.scCategory == 'No'">
                    <label class="col-md-3">Remark : <span class="error">*</span></label>
                    <div class="col-md-9">
                      <b-form-textarea :formatter="capitalizeAll" id="remark" name="remark"
                        v-model="itm.scremark"></b-form-textarea>
                      <span class="error" v-if="
                        itm.scremark == '' ||
                        itm.scremark == null ||
                        itm.scremark == undefined
                      ">
                        Bill to Shipper Remark Field is Required</span>
                    </div>
                  </div>
                  <div class="col-md-4 row" v-if="itm.dispute_status === 'Resolved' && itm.scCategory==='Yes'">
                    <label class="col-md-3">Amount : <span class="error">*</span></label>
                    <div class="col-md-9">
                      <b-form-input type="number" v-model="itm.resolved_amount"></b-form-input>
                      <span class="error" v-if="itm.resolved_amount_err">{{ itm.resolved_amount_err }}</span>
                    </div>
                  </div>
                  <!-- Supplementary Comment Yes NO Section End -->
                </div>
                <!-- <div v-if="viewInvDoc.length > 0">
                  <md-layout md-gutter class="gutr">
                    <md-layout
                      md-flex="40"
                      v-for="(item, index) in viewInvDoc"
                      :key="index"
                    >
                      <a
                        v-if="ImportDetail.ccImportSeries"
                        :href="
                          `${docURL}/ASSIGNMENT_UPLOADS/` +
                          ImportDetail.ccImportSeries.replaceAll('/', '_') +
                          '/' +
                          item
                        "
                        target="_blank"
                        download
                        >--View Document - {{ index + 1 }}</a
                      ><br />
                      <a
                        :href="
                          `${docURL}/Import_Sline_Payments_Uploads/` + item
                        "
                        target="_blank"
                        download
                        >--View Document - {{ index + 1 }}</a
                      >
                    </md-layout>
                  </md-layout>
                </div> -->

                <!-- ADD AMOUNT BUTTON  -->
                <!-- <b-row align-v="start">
                  <div 
                    class="d-flex align-items-center mt-3"
                    >
                      <b-button
                      class="ml-3"
                        id="show-btn"
                        size="sm"
                        variant="warning"
                        @click="addInvCurrency(idx)"
                      >
                        ADD AMOUNT <i class="fa fa-plus" aria-hidden="true"></i
                      ></b-button>

                    </div>
                </b-row> -->
                <!-- END ADD AMOUNT BUTTON  -->

                <!-- AMOUNT DETAILS START-->

                <b-card class="mt-2" v-for="(currItm, currIdx) in itm['invCurrencyList']" :key="currIdx">
                  <div>
                    <!-- REMOVE AMOUNT BUTTON  -->
                    <b-row v-if="currIdx != 0">
                      <b-col>
                        <div class="d-flex align-items-center mt-3">
                          <b-button class="ml-auto" id="show-btn" size="sm" variant="outline-danger"
                            @click="removeInvCurrency(idx, currIdx)">
                            REMOVE AMOUNT
                            <i class="fa fa-plus" aria-hidden="true"></i></b-button>
                        </div>
                      </b-col>
                    </b-row>

                    <!-- AMOUNT FIELDS START  -->

                    <div>
                      <b-row>
                        <b-col cols="3">
                          <label>Invoice Amount<span class="error">*</span></label>
                          <b-form-input :formatter="capitalizeAll" :disabled="(accounts == true && role != 'Admin') ||
                            itm.enableDisable == true
                            ? true
                            : false
                            " name="shippingBillNo" id="shippingBillNo" v-model="currItm.invAmount"
                            type="number"></b-form-input>
                          <span class="error" v-if="currItm.invAmount_err ? true : false">{{ currItm.invAmount_err
                            }}</span></b-col>

                        <b-col cols="3"><label>Currency<span class="error">*</span></label>

                          <model-list-select :isDisabled="(accounts == true && role != 'Admin') ||
                            itm.enableDisable == true
                            ? true
                            : false
                            " :list="currList" v-model="currItm.invCurrency" option-value="payVal"
                            option-text="payText" placeholder="Select Currency"></model-list-select>
                          <span class="error" v-if="currItm.invCurrency_err ? true : false">{{ currItm.invCurrency_err
                            }}</span>
                        </b-col>

                        <b-col v-if="
                          (SBDetail.SlinePayId != '' && accounts == true) ||
                          (SBDetail.SlinePayId != '' && role == 'Admin')
                        "><label>Payment Mode</label>

                          <model-list-select :isDisabled="accounts != true && role != 'Admin' || currItm.invPayStatus != '' ? true : false
                            " :list="payList" v-model="currItm.invPayMode" option-value="payVal" option-text="payText"
                            placeholder="Select Mode"></model-list-select>
                          <span class="error" v-if="currItm.invPayMode_err ? true : false">{{ currItm.invPayMode_err
                            }}</span>
                        </b-col>
                        <b-col v-if="
                          (SBDetail.SlinePayId != '' && accounts == true) ||
                          (SBDetail.SlinePayId != '' && role == 'Admin')
                        "><label>Payment Ref</label>
                          <b-form-input :disabled="((accounts != true) || (currItm.invPayStatus != '' && $sessionsStorage.get('cust_username') != 'laxmi@pridel.com' && role != 'Admin')) ? true : false
                            " :formatter="capitalizeAll" name="shippingBillNo" id="shippingBillNo"
                            v-model="currItm.invPayRef" @input="cahngeDisableButton(currItm.invPayRef)"></b-form-input>
                          <span class="error" v-if="currItm.invPayRef_err ? true : false">{{ currItm.invPayRef_err
                            }}</span>
                        </b-col>
                      </b-row>

                      <b-row v-if="
                        (SBDetail.SlinePayId != '' && accounts == true) ||
                        (SBDetail.SlinePayId != '' && role == 'Admin')
                      ">
                        <b-col cols="4"><label>Payment Amount</label>
                          <b-form-input :disabled="accounts != true && role != 'Admin' || currItm.invPayStatus != '' ? true : false
                            " :formatter="capitalizeAll" name="shippingBillNo" id="shippingBillNo"
                            v-model="currItm.invPaidAmount"></b-form-input>
                          <span class="error" v-if="currItm.invPaidAmount_err ? true : false">{{
                            currItm.invPaidAmount_err }}</span>
                        </b-col>
                        <b-col class="mt-4" cols="4"><label>Payment Date</label>
                          <date-picker :disabled="((accounts != true) || (currItm.invPayStatus != '' && $sessionsStorage.get('cust_username') != 'laxmi@pridel.com' && role != 'Admin')) ? true : false
                            " :format="selectDateFormat" lang="en" name="shippingBillNo" id="shippingBillNo"
                            v-model="currItm.invPayDate" :minute-step="1"
                            @input="cahngeDisableButton(currItm.invPayDate)"></date-picker>
                          <span class="error" v-if="currItm.invPayDate_err ? true : false">{{ currItm.invPayDate_err
                            }}</span>
                        </b-col>
                        <b-col cols="4"><label>Payment Status</label>
                          <!-- {{currItm.invPayStatus}} -->
                          <!-- :disabled="currItm.invPayStatus== '2' ? true : false" -->
                          <model-list-select :isDisabled="accounts != true && role != 'Admin' || currItm.invPayStatus != '' ? true : false
                            " :list="statusList" v-model="currItm.invPayStatus" option-value="payVal"
                            option-text="payText" placeholder="Select Status"></model-list-select>
                          <span class="error" v-if="currItm.invPayStatus_err ? true : false">{{ currItm.invPayStatus_err
                            }}</span>
                        </b-col>
                        <b-col></b-col>
                      </b-row>
                    </div>

                    <!-- AMOUNT FIELDS END  -->
                  </div>
                </b-card>
              </b-card>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="25">
                  <!-- <b-button
                    v-if="lineInvModalArray.length > 0"
                    class="mt-3"
                    :disabled="
                      SBDetail.paymentDone == '1' || disableSave == true
                        ? true
                        : false
                    "
                    variant="primary"
                    id="addButtonLoaderSB"
                    @click="addSBDetail"
                    >Save & Submit
                  </b-button> -->
                  <!-- :disabled="
                      SBDetail.paymentDone == '1' || disableSave == true
                        ? true
                        : false -->
                  "
                  <b-button v-if="lineInvModalArray.length > 0" :disabled="addSBDetail_button == true || ((SBDetail.paymentDone == '1' || disableSaveSubmit == true) && !isDisputeResolved)
                    ? true
                    : false
                    " class="mt-3" variant="primary" id="addButtonLoaderSB" @click="addSBDetail">Save & Submit
                  </b-button>

                  <md-spinner md-indeterminate id="loaderSB" style="display: none"></md-spinner>
                </md-layout>
              </md-layout>
            </div>
            <!-- <div class="mt-4" v-if="suplimentaryInvData.length > 0">
              <h5>Supplementary Invoice</h5>
              <table class="table table-sm table-bordered">
                <tbody>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Invoice Added Date</th>
                    <th scope="col">Invoice Amount</th>
                    <th scope="col">SOB Date</th>
                    <th scope="col">Due Date</th>
                    <th scope="col">Payment Status</th>
                    <th scope="col">Amount Paid</th>
                    <th scope="col">Payment Date</th>
                    <th scope="col">Action</th>
                  </tr>
                  <tr v-for="(item, index) in suplimentaryInvData" :key="index">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ item.loginTime }}</td>
                    <td>{{ item.invoiceAmount }}</td>
                    <td>{{ item.sobDate }}</td>
                    <td>{{ item.dueDate }}</td>
                    <td :bgcolor="item.paymentDone == '1' ? 'Green' : 'Red'">
                      {{ item.paymentDone == "1" ? "Completed" : "Pending" }}
                    </td>
                    <td>{{ item.totalAmount }}</td>
                    <td>{{ item.payDate }}</td>
                    <td>
                      <b-button
                        size="sm"
                        @click="getSingleSupPay(item.supSlinePayId)"
                        variant="outline-primary"
                        >Edit / Make Payment</b-button
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div> -->
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div>
      <b-modal id="supModal" ref="my-modal" size="xl" hide-footer title="">
        <suplimentry-inv :suplimentaryInvDataSingleArry="getSuplimentaryInvData" :key="componentKey" />
        <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Close</b-button>
        <!-- <b-button class="mt-2" variant="outline-warning" block @click="toggleModal">Toggle Me</b-button> -->
      </b-modal>
    </div>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="popMailAfter"></md-dialog-confirm>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import SuplimentryInv from "../CCImport/SuplementrySlinePaymentImp.vue";
import Multiselect from "vue-multiselect";
import MultiFileUploader from "../common/MultiSlineFileUploader.vue";
import RemoveSlineInvoiceButton from "../common/RemoveSlineInvoiceButton.vue";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalContainerValid,
} from "../../helper/collection";

export default {
  beforeMount() {
    this.$store.dispatch("common/setAllRemarkDDList", { search_txt: "",ModuleType:"SLINE DISPUTE" });
    // alert(this.$sessionsStorage.get("editCcType"));
    if (
      (globalPermissionStatus("Custom Clearance") ||
        globalPermissionStatus("Accounts")) &&
      this.$sessionsStorage.get("editCcImportId") != undefined &&
      this.$sessionsStorage.get("editCcImportId") != ""
    ) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/CCImport/ccSLinePaymentImportN"
      );
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    ContainerTypeSizefactory: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("containerNo")) {
          this.ContainerTypeSizefactory.containerNo =
            newVal.containerNo.toUpperCase();

          if (this.ContainerTypeSizefactory.packageId != "") {
            let arrayNew = this.packageNameList.filter((x) => {
              return x.packageId == this.ContainerTypeSizefactory.packageId;
            });

            if (arrayNew.length > 0) {
              this.ContainerTypeSizefactory.packageName =
                arrayNew[0].packageName;
            }
          }
        }
      },
      deep: true,
    },
  },

  data() {
    return {
      FFSeaExportArr: [],
      disableSaveSubmit: false,
      addSBDetail_button: false,
      syncFlag: false,
      invnoErrFlag: false,
      selectDateFormat,
      accounts: globalPermissionStatus("Accounts"),
      invBlDraftUpload: "",
      componentKey: 0,
      revisedInvoiceDetails: [],
      selectedInvoice: [],
      items: [],
      lastSelectItem: {},
      payList: [
        {
          payVal: "1",
          payText: "RTGS",
        },
        {
          payVal: "2",
          payText: "Cheque",
        },
      ],
      statusList: [
        // {
        //   payVal: "1",
        //   payText: "PARTIAL",
        // },
        {
          payVal: "2",
          payText: "COMPLETED",
        },
      ],
      currList: [
        {
          payVal: "INR",
          payText: "INR",
        },
        {
          payVal: "USD",
          payText: "USD",
        },
      ],
      invCategoryList: [
        {
          payVal: "Supplementary",
          payText: "Supplementary",
          notEnabled: true,
        },
        {
          payVal: "Normal",
          payText: "Normal",
          notEnabled: true,
        },
      ],
      SCCategoryList: [
        {
          SCVal: "Yes",
          SCText: "Yes",
          // notEnabled: true,
        },
        {
          SCVal: "No",
          SCText: "No",
          // notEnabled: true,
        },
      ],
      invoiceTypeList: [
        {
          value: "1",
          text: "OCEAN FREIGHT",
        },
        {
          value: "2",
          text: "DETENTION CHARGES",
        },
        {
          value: "3",
          text: "SURRENDER CHARGES",
        },
        {
          value: "4",
          text: "LDC CHARGES",
        },
        {
          value: "5",
          text: "LOCAL CHARGES",
        },
        //Extra Added
        {
          value: "6",
          text: "SEAL CHARGES",
        },
        {
          value: "7",
          text: "VIA CHARGES",
        },
        {
          value: "8",
          text: "STORAGE CHARGES",
        },
        {
          value: "9",
          text: "ROLL-ON CHARGES",
        },
        {
          value: "10",
          text: "TERMINAL HANDLING CHARGES (THC)",
        },
        {
          value: "11",
          text: "SEAWAY BL CHARGES",
        },
        {
          value: "12",
          text: "ORIGINAL BL CHARGES",
        },
        {
          value: "13",
          text: "B/L AMENDMENT CHARGES",
        },
        {
          value: "14",
          text: "DESTINATION CHARGES",
        },
        {
          value: "15",
          text: "CREDIT NOTE",
        },
        {
          value: "16",
          text: "BOOKING CANCELLATION",
        },
      ],
      showAlgo: false,
      algoConNo: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      value12: "",
      CCdone: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      unitList: [
        {
          uT: "KGS",
          uV: "KGS",
        },
        {
          uT: "MT",
          uV: "MT",
        },
      ],

      CCList: [
        {
          ccInfoVal: "Yes",
          ccInfoText: "Yes",
        },
        {
          ccInfoVal: "No",
          ccInfoText: "No",
        },
      ],
      getContainerList: [],
      getLocationList: [],
      ImportDetail: {
        POD: "",
        allModuleId: "",
        clientName: "",
        ccImportSeries: "",
        portType: "",
        stuffingType: "",
        containerInfo: "",
        mergeffExportId: "",
        mergeSeries: "",
        shippingLine: "",
        FinalPlace: "",
        POR: "",
        username: "",
      },
      POR: "",
      POR_err: "",
      SBDetail: {
        dueDate_err: "",
        sobDate_err: "",
        blDraftUpload_err: "",
        SlineBlNo_err: "",

        // POR_err: "",

        POR: "",
        moduleType: "",
        revisedMail: "0",
        dueDate: "",
        SlineBlNo: "",
        invoiceAmount: "",
        sobDate: "",
        allModuleId: "",
        paymentDone: "",
        userId: "",
        stuffingType: "",
        blDraftUpload: "",
        slineInvoice: "",
        suplimentaryInvCount: "",
        supSlinePayId: "",
        SlinePayId: "",
        ccExportId: "",
        CCExecutionId: "",

        paymentMode: "",
        totalAmount: "",
        payRefNumber: "",
        payDate: "",
        salesExeuctionNo: "",
        sline: "",
        clientName: "",
      },

      errorSBExecution: {
        // shippingBillDate: "",
        // shippingBillNo: "",
        sobDate: "",
        SlineBlNo: "",

        cargoGrossWeight: "",
      },
      arraySBExecutionError: [
        "Enter Shippping Bill Date",
        "Enter Shipping Bill No",
        "Enter Cargo Weight",
      ],
      errorAtleastSb: "",
      errorAtleastContainer: "",

      WarehouseStuffing: {
        vgmSubmissionDate: "",
        gateInDate: "",
        siSubmissionDate: "",
        ccExecutionId: "",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),

        stuffingType: "",
        portType: "",

        nameOfCFS: "",
        cartingDate: "",
        crnNumber: "",

        custmClearByPridel: "",
        ccAsignmentNo: "",
        containerInfo: "",
      },
      permissionStatus: true,
      sbDetailArray: [],
      suplimentaryInvData: [],
      getSuplimentaryInvData: [],
      showMoreSB: false,

      errorExecution: {
        cartingDate: "",
        crnNumber: "",
      },
      nameOfCFSError: "",
      arrayExecutionError: ["Select Carting Date", "Enter CRN Number"],

      ContainerTypeSizefactory: {
        netWeight: "",
        weightUnit: "",
        ccExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        cargoStuffingDate: "",
        leeoDate: "",
        leeoNo: "",
        handoverDate: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },

      removeContainerVmodel: {
        ccExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },
      role: this.$sessionsStorage.get("designation"),
      packageNameList: [],
      nextPageType: "",

      errorContainer: {
        containerTypeId: "",
        containerNo: "",
        grossWeight: "",
        //    measurement: "",
        packageId: "",
        noOfpkgUnit: "",
      },
      arrayContainerError: [
        "Select Container Type",
        "Enter Container No.",
        "Enter Container Gross Weight1",
        // "Enter measurement",
        "Select Package",
        "Enter No of Packages",
      ],
      ContainerFromTPT: [],
      ContainerNoTPT: [],
      ContainerNoTypeTPT: [],
      editIndex: "",
      deleteId: "",
      showDivCountNote: false,
      lineInvModalArray: [],
      BookingShippingLine: {
        assignmentNumber: "",
        bookingNumber: "",
        uploadBooking: "",
        validityBookingDate: "",
        bookingDate: "",
        vesselName: "",
        SICutOff: "",
        gateOpenDate: "",
        gateOpenTime: "",
        gateCloseDate: "",
        gateCloseTime: "",
        portCutDate: "",
        portCutTime: "",
        ENSCutDate: "",
        ENSCutTime: "",
        bookingShipment: "",
        stuffingType: "",
        vesselEta: "",
        vesselEtd: "",
        vgmCutOffDate: "",
        documentCutOffDate: "",
        voyageNo: "",
      },
      validateTrans: true,
      validateSB: true,
      containerTypeDetailFactory: [],
      containerNoRegexError: "",
      fileType: "",
      fileUrl: "",
    };
  },

  mounted() { },

  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    MultiSelect,
    // Loading,
    CustomLoader,
    SuplimentryInv,
    BannerComponent,
    Multiselect,
    MultiFileUploader,
    RemoveSlineInvoiceButton,
  },
  created() {
    eventBus.$on("fileuploaded", (file) => {
      console.log("PS=>", file);
      this.fileType = "";
      this.fileUrl = "";
      this.SBDetail.slineInvoice = file.url;
      if (file.folderName == "BL_DRAFT") {
        this.fileType = file.folderName;
        this.SBDetail.blDraftUpload = "";
        this.SBDetail.blDraftUpload = file.url;
        this.fileUrl = file.url;
      } else if (file.folderName == "Sline_Invoice") {
        this.fileType = file.folderName;
        this.fileUrl = file.url;
      }
    });
    eventBus.$on("fileuploadedsecondindex", (indexObj) => {
      console.log("fileuploadedsecondindex=>", indexObj);
      if (this.fileType != "BL_DRAFT") {
        this.lineInvModalArray[indexObj.second_index].invSlineUpload = this.fileUrl;
      }
    });
  },
  computed: {
    isDisputeResolved() {
      return this.lineInvModalArray.some((itm) => itm.dispute_status === "Resolved");
    },
    disableSave() {
      return this.accounts == false &&
        this.role != "Admin" &&
        (!this.SBDetail.SlineBlNo ||
          !this.SBDetail.invoiceAmount ||
          !this.SBDetail.sobDate)
        ? true
        : false;
    },
    viewBLDraftDoc() {
      return this.SBDetail.blDraftUpload != ""
        ? this.SBDetail.blDraftUpload.split(",")
        : [];
    },
    viewInvDoc() {
      return this.SBDetail.slineInvoice != ""
        ? this.SBDetail.slineInvoice.split(",")
        : [];
    },

    viewSlineInvDoc() {
      return this.SBDetail.slineInvoice != ""
        ? this.SBDetail.slineInvoice.split(",")
        : [];
    },
    sbDetailArrayList() {
      return this.sbDetailArray;
    },
    containerTypeDetailFactoryList() {
      return this.containerTypeDetailFactory;
    },
    ContainerTypeList() {
      return this.getContainerList;
    },
    masterList() {
      return this.getLocationList;
    },
  },
  methods: {
    searchSlineDispute(val) {
      this.$store.dispatch("common/setAllRemarkDDList", { search_txt: val,ModuleType:"SLINE DISPUTE" });
    },
    debounceSearch(val) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.searchSlineDispute(val);
      }, 500);
    },
    refreshData() {
      // Add the logic here to refresh the data in the parent component
      console.log("Data refreshed in the parent component");
      // For example, you could re-fetch data from the API or update local data
      this.getData();
    },
    cahngeDisableButton(item) {
      if (item != undefined && item != null) {
        this.disableSaveSubmit = false;
        this.SBDetail.paymentDone = '';
      }
    },
    onSelectionChange(event) {
      console.log("Events= > ", event);
    },
    onSelect(items, lastSelectItem, itemNew, index) {
      console.log(items, lastSelectItem, itemNew);
      itemNew.invType = items;
    },
    onSelect2(index, items, lastSelectItem) {
      this.items = items;
      this.lastSelectItem = lastSelectItem;
      this.lineInvModalArray[index].invTypeArr = items;

      this.lineInvModalArray[index].invType = JSON.stringify(this.items);
      console.log(this.lineInvModalArray[index].invType);
    },
    // deselect option
    reset() {
      this.items = []; // reset
    },
    // select option from parent component
    selectFromParentComponent() {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual);
      console.log("Item =>", this.items);
    },
    addInvArry() {
      this.SBDetail.paymentDone = '';
      let invCategory_val = '';
      // alert(this.SBDetail.SlinePayId);
      if (this.SBDetail.SlinePayId == '') {
        invCategory_val = "Normal";
      } else {
        invCategory_val = "Supplementary";
      }
      (this.disableSaveSubmit = false), console.log("Add invoice");
      let obj = {
        SlineInvId: "",
        enableDisable: false,
        invId: "",
        ccExportId: "",
        allModuleId: "",
        invSlineUpload: "",
        invBlDraftUpload: "",
        invNo: "",
        inv_date: "",
        invAmount: "",
        invCurrency: "",

        invCurrencyList: [
          {
            invAmount: "",
            invCurrency: "",
            invPayMode: "",
            invPaidAmount: "",
            invPayRef: "",
            invPayDate: "",
            invPayStatus: "",

            invAmount_err: "",
            invCurrency_err: "",
            invPayMode_err: "",
            invPaidAmount_err: "",
            invPayRef_err: "",
            invPayDate_err: "",
            invPayStatus_err: "",
          },
        ],
        invType: [],
        // invType: "",
        invCategory: invCategory_val,
        scCategory: "",
        scremark: "",
        invTypeArr: [],
        invPayMode: "",
        invPaidAmount: "",
        invPayRef: "",
        invPayDate: "",
        invPayStatus: "",

        dispute_status: "",
        sline_dispute: "",
        resolved_amount: "",

        invCategory_err: "",
        scCategory_err: "",
        scremark_err: "",
        invSlineUpload_err: "",
        invType_err: "",
        invNo_err: "",
        inv_date_err: "",
        sline_dispute_err: "",
        resolved_amount_err: "",
      };
      this.lineInvModalArray.push(obj);

      console.log(this.lineInvModalArray.length);
    },

    addInvCurrency(index) {
      let obj = {
        invAmount: "",
        invCurrency: "",
        invPayMode: "",
        invPaidAmount: "",
        invPayRef: "",
        invPayDate: "",
        invPayStatus: "",
      };

      this.lineInvModalArray[index].invCurrencyList.push(obj);
    },

    RevisedAss(id) {
      // alert(id);
      var checkBox = document.getElementById(id).checked;
      console.log("Id => " + id + " : " + checkBox);
      if (checkBox) {
        // console.log("lineInvModalArray",this.lineInvModalArray);return false;
        // this.SBDetail.blDraftUpload="",
        // this.SBDetail.sobDate="",
        // this.SBDetail.SlineBlNo="",
        // this.SBDetail.dueDate="",
        // (this.items = []), (this.lastSelectItem = {});
        // for (let i = 0; i < lineInvModalArray.length; i++) {
        //   this.lineInvModalArray[i].invType = "";
        //   this.lineInvModalArray[i].invCategory = "";
        //   this.lineInvModalArray[i].invTypeArr = "";
        //   this.lineInvModalArray[i].invPayMode = "";
        //   this.lineInvModalArray[i].invPaidAmount = "";
        //   this.lineInvModalArray[i].invPayRef = "";
        //   this.lineInvModalArray[i].invPayDate = "";
        //   this.lineInvModalArray[i].invPayStatus = "";
        //   let obj = {
        //     invAmount: "",
        //     invCurrency: "",
        //     invPayMode: "",
        //     invPaidAmount: "",
        //     invPayRef: "",
        //     invPayDate: "",
        //     invPayStatus: "",
        //   };
        //   this.lineInvModalArray[i].invCurrencyList.push(obj);
        //   this.lineInvModalArray[i].invCurrencyList[i].invAmount = "";
        //   this.lineInvModalArray[i].invCurrencyList[i].invCurrency = "";
        // let obj = {
        //   invId: "",
        //   ccExportId: "",
        //   allModuleId: "",
        //   invSlineUpload: "",
        //   invBlDraftUpload: "",
        //   invNo: "",
        //   invAmount: "",
        //   invCurrency: "",
        //   invCurrencyList : [{
        //     invAmount: "",
        //     invCurrency: "",
        //     invPayMode: "",
        //     invPaidAmount: "",
        //     invPayRef: "",
        //     invPayDate: "",
        //     invPayStatus: "",
        //   }],
        //   invType: "",
        //   invCategory : "",
        //   invTypeArr: [],
        //   invPayMode: "",
        //   invPaidAmount: "",
        //   invPayRef: "",
        //   invPayDate: "",
        //   invPayStatus: "",
        // };
        // this.lineInvModalArray.push(obj);
        // }
        //  this.lineInvModalArray= []
      }
    },

    addRevisedInvoice(index, id) {
      var checkBox = document.getElementById(id).checked;
      console.log("Id => " + id + " : " + checkBox);
      if (checkBox) {
        this.disableSaveSubmit = false;
        this.lineInvModalArray[index].enableDisable = false;
        this.lineInvModalArray[index]["Counter"] = index;
        this.revisedInvoiceDetails.push(this.lineInvModalArray[index]);
        // this.lineInvModalArray[index].invSlineUpload = "";
        // this.lineInvModalArray[index].invCurrencyList[0].invAmount = "";
        // this.lineInvModalArray[index].invType = "";
        // this.lineInvModalArray[index].invCategory = "";
        this.lineInvModalArray[index].invSlineUpload = "";
        this.lineInvModalArray[index].invCurrencyList[0].invAmount = "";
        // this.lineInvModalArray[index].invSlineUpload = "";
        // this.lineInvModalArray[index].invNo = "";
        // // this.lineInvModalArray[index].invoiceTypeList = "";
        // this.lineInvModalArray[index].invTypeArr = "";
        // this.lineInvModalArray[index].invPayMode = "";
        // this.lineInvModalArray[index].invPaidAmount = "";
        // this.lineInvModalArray[index].invPayRef = "";
        // this.lineInvModalArray[index].invPayDate = "";
        // this.lineInvModalArray[index].invPayStatus = "";
      } else {
        this.revisedInvoiceDetails.splice(index, 1);
      }

      console.log("Revised mail => ", this.revisedInvoiceDetails);
    },

    removeInvArry(index) {
      this.lineInvModalArray.splice(index, 1);
    },
    removeInvCurrency(invIndex, currIndex) {
      this.lineInvModalArray[invIndex].invCurrencyList.splice(currIndex, 1);
    },
    getSingleSupPay(itemId) {
      this.componentKey += 1;
      this.getSuplimentaryInvData = [];
      let arraysing = this.suplimentaryInvData.filter((y) => {
        return y.supSlinePayId == itemId;
      });

      if (arraysing.length > 0) {
        this.getSuplimentaryInvData = arraysing;
        this.getSuplimentaryInvData[0]["suplimentaryInvCount"] =
          this.SBDetail.suplimentaryInvCount;
        this.$refs["my-modal"].show();
      }
    },
    showModal() {
      this.componentKey += 1;
      this.getSuplimentaryInvData = [];
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.getSuplimentaryInvData = [];
      this.$refs["my-modal"].hide();
      this.getData();
    },
    getDueDate() {
      var date = new Date(this.SBDetail.sobDate);
      console.log(date);
      if (this.ImportDetail.shippingId == "15") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 9);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else if (this.ImportDetail.shippingId == "8") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 9);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else if (this.ImportDetail.shippingId == "13") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 9);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else if (this.ImportDetail.shippingId == "27") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 13);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 6);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      }
    },
    onFileChangeBlDraft(ID, index) {
      this.isLoading = true;
      let files = event.target.files || event.dataTransfer.files;
      let ccImportId = this.$sessionsStorage.get("editCcImportId");
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);

        if (ID == "Sline_Invoice") {
          formData.append(
            "staticFileName",
            "CC_Import_SlinePay_SlineInv_" + ccImportId
          );
        } else if (ID == "BL_DRAFT") {
          formData.append(
            "staticFileName",
            "CC_Import_SlinePay_BLDraft_" + ccImportId
          );
        }

        formData.append(
          "upload_dir_folderName",
          // "CC_Sea_Import_Sline_Payments_Uploads"
          this.ImportDetail.ccImportSeries.replaceAll("/", "_")
        );
      }

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: ID + ccImportId,
        },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          if (ID == "BL_DRAFT") {
            this.SBDetail.blDraftUpload = result.data;
          } else {
            this.lineInvModalArray[index].invSlineUpload = result.data;
            this.SBDetail.slineInvoice = result.data;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          throw err;
        });
    },

    getConAlgoList() {
      //let self = this;

      if (this.ContainerTypeSizefactory.containerNo != "") {
        this.validContainerNo = GlobalContainerValid(
          this.ContainerTypeSizefactory.containerNo
        );
      }
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      window.history.go(-1);
    },

    // validateSBDetail() {
    //   let validate_new = true;
    //   Object.keys(this.errorSBExecution).map((x, index) => {
    //     if (this.SBDetail[x] == "") {
    //       this.errorSBExecution[x] = this.arraySBExecutionError[index];
    //       validate_new = false;
    //     }
    //   });

    //   console.log(this.errorSBExecution);

    //   if (validate_new == false) {
    //     this.validateSB = false;
    //   } else {
    //     this.validateSB = true;
    //   }
    // },
    showMoreSBDet() {
      if (this.showMoreSB == false) {
        this.ContainerTypeSizefactory.ccExecutionContainerId == "";
        this.showMoreSB = true;
      } else {
        this.showMoreSB = false;
      }
    },
    viewEdit(id, index) {
      let array = this.containerTypeDetailFactory.filter((x) => {
        return x.ccExecutionContainerId == id;
      });

      Object.keys(this.ContainerTypeSizefactory).map((x) => {
        this.ContainerTypeSizefactory[x] = array[0][x];
      });
      this.showMoreSB = false;
    },

    checkInvNo() {
      return new Promise((resolve) => {
        (this.SBDetail["module_type"] = "CC Import"),
          (this.SBDetail["allModuleId"] = this.ImportDetail.allModuleId),
          (this.SBDetail["ccExportId"] =
            this.$sessionsStorage.get("editCcImportId"));
        this.SBDetail["CCExecutionId"] =
          this.$sessionsStorage.get("editCCExecutionId");
        this.SBDetail.invoiceDetails = this.lineInvModalArray;
        if (this.lineInvModalArray.length > 0) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_SlineBillingCCExport/checkInvNoExist.php`,
            data: JSON.stringify(this.SBDetail),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                console.log(data);
                console.log(data.find);
                // alert(data.find);
                if (data.find == 1) {
                  this.invnoErrFlag = true;
                } else if (data.find == 2) {
                  this.invnoErrFlag = true;
                } else if (data.find == 0) {
                  this.invnoErrFlag = false;
                }

                this.syncFlag = true;
                console.log("Check");
                return resolve(!this.invnoErrFlag);
              }
            })
            .catch((error) => { });
        }
      });
    },
    validateSBDetail() {
      // alert("Hello");
      let validate_new = true;
      let i = 0;
      let errCount = 0;
      let errCount1 = 0;
      let errCount2 = 0;
      if (this.accounts != true || this.role == "Admin") {
        if (this.POR == "") {
          this.POR_err = "POR Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.POR_err = "";
          validate_new = true;
        }

        if (this.ImportDetail.shippingLine == "") {
          this.ImportDetail.shippingLine_err =
            "Shipping Line Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.ImportDetail.shippingLine_err = "";
          validate_new = true;
        }

        if (this.SBDetail.SlineBlNo == "") {
          this.SBDetail.SlineBlNo_err = "B/L No. Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.SBDetail.SlineBlNo_err = "";
          validate_new = true;
        }

        if (this.SBDetail.blDraftUpload == "") {
          this.SBDetail.blDraftUpload_err = "B/L Draft Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.SBDetail.blDraftUpload_err = "";
          validate_new = true;
        }

        if (this.SBDetail.sobDate == "") {
          this.SBDetail.sobDate_err = "Estimated SOB Date Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.SBDetail.sobDate_err = "";
          validate_new = true;
        }

        if (this.SBDetail.dueDate == "") {
          this.SBDetail.dueDate_err = "Payment Due Date Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.SBDetail.dueDate_err = "";
          validate_new = true;
        }

        let j = 0;
        let MainARR = this.lineInvModalArray;
        for (let j = 0; j < MainARR.length; j++) {
          if (MainARR[j].invCategory == "") {
            this.lineInvModalArray[j]["invCategory_err"] =
              "Invoice Category Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invCategory_err"] = "";
            validate_new = true;
          }
          if (MainARR[j].invCategory == "Normal") {
            this.lineInvModalArray[j]["scremark_err"] = "";
            this.lineInvModalArray[j]["scCategory_err"] = "";
          }

          if (MainARR[j].invCategory == "Supplementary" || MainARR[j].dispute_status === "Resolved") {
            if (
              MainARR[j].scCategory == "No" ||
              MainARR[j].scCategory == "Yes"
            ) {
              this.lineInvModalArray[j]["scCategory_err"] = "";
              validate_new = true;
            }
            if (
              MainARR[j].scCategory == "" ||
              MainARR[j].scCategory == null ||
              MainARR[j].scCategory == undefined
            ) {
              this.lineInvModalArray[j]["scCategory_err"] =
                "Bill to Shipper Field is Required";
              validate_new = false;
              ++errCount;
              break;
            } else {
              this.lineInvModalArray[j]["scCategory_err"] = "";
              validate_new = true;
            }

            if (MainARR[j].scCategory == "Yes" || MainARR[j].scCategory == "No") {
              if (
                MainARR[j].scremark == "" ||
                MainARR[j].scremark == null ||
                MainARR[j].scremark == undefined
              ) {
                this.lineInvModalArray[j]["scremark_err"] =
                  "Bill to Shipper Remark Field is Required";
                validate_new = false;
                ++errCount;
                break;
              } else {
                this.lineInvModalArray[j]["scremark_err"] = "";
                validate_new = true;
              }
            } else if (MainARR[j].scCategory == "No") {
              this.lineInvModalArray[j]["scCategory_err"] = "";
              validate_new = true;
              this.lineInvModalArray[j]["scremark_err"] = "";
              validate_new = true;
            }
          } else {
            this.lineInvModalArray[j]["scremark_err"] = "";
            validate_new = true;
            this.lineInvModalArray[j]["scCategory_err"] = "";
            validate_new = true;
          }
          if (MainARR[j].invSlineUpload == "") {
            this.lineInvModalArray[j]["invSlineUpload_err"] =
              "Shipping Line Invoice Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invSlineUpload_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].invNo == "") {
            this.lineInvModalArray[j]["invNo_err"] =
              "Invoice No. Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invNo_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].inv_date == "") {
            this.lineInvModalArray[j]["inv_date_err"] =
              "Invoice Date. Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["inv_date_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].invType == "") {
            this.lineInvModalArray[j]["invType_err"] =
              "Invoice Type Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invType_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].dispute_status) {
            if (!MainARR[j].sline_dispute) {
              this.lineInvModalArray[j]["sline_dispute_err"] = "Sline Dispute Reason is Required";
              validate_new = false;
              ++errCount;
              break;
            } else {
              this.lineInvModalArray[j]["sline_dispute_err"] = "";
              validate_new = true;
            }
            if (MainARR[j].dispute_status === "Resolved" &&MainARR[j].scCategory === "Yes") {
              if (!MainARR[j].resolved_amount) {
                this.lineInvModalArray[j]["resolved_amount_err"] = "Amount is Required";
                validate_new = false;
                ++errCount;
                break;
              } else {
                this.lineInvModalArray[j]["resolved_amount_err"] = "";
                validate_new = true;
              }
            }
          }

          let MainARR2 = MainARR[j].invCurrencyList;
          for (let k = 0; k < MainARR2.length; k++) {
            if (MainARR2[k].invAmount == "") {
              this.lineInvModalArray[j].invCurrencyList[k]["invAmount_err"] =
                "Invoice Amount Field is Required";
              validate_new = false;
              ++errCount2;
              break;
            } else {
              this.lineInvModalArray[j].invCurrencyList[k]["invAmount_err"] =
                "";
              validate_new = true;
            }

            if (MainARR2[k].invCurrency == "") {
              this.lineInvModalArray[j].invCurrencyList[k]["invCurrency_err"] =
                "Invoice Currency Field is Required";
              validate_new = false;
              ++errCount2;
              break;
            } else {
              this.lineInvModalArray[j].invCurrencyList[k]["invCurrency_err"] =
                "";
              validate_new = true;
            }
          }
        }
      } else if (this.accounts == true || this.role == "Admin") {
        let MainARR = this.lineInvModalArray;
        for (let j = 0; j < MainARR.length; j++) {
          let MainARR2 = MainARR[j].invCurrencyList;
          for (let k = 0; k < MainARR2.length; k++) {
            if (MainARR2[k].invPaidAmount != "" || MainARR2[k].invPayStatus == "2") {
              if (MainARR2[k].invPaidAmount == "") {
                this.lineInvModalArray[j].invCurrencyList[k][
                  "invPaidAmount_err"
                ] = "Payment Amount Field is Required";
                validate_new = false;
                ++errCount2;
                break;
              } else {
                this.lineInvModalArray[j].invCurrencyList[k][
                  "invPaidAmount_err"
                ] = "";
                validate_new = true;
              }

              if (MainARR2[k].invPayMode == "") {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayMode_err"] =
                  "Payment Mode Field is Required";
                validate_new = false;
                ++errCount2;
                break;
              } else {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayMode_err"] =
                  "";
                validate_new = true;
              }

              if (MainARR2[k].invPayRef == "") {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayRef_err"] =
                  "Payment Ref Field is Required";
                validate_new = false;
                ++errCount2;
                break;
              } else {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayRef_err"] =
                  "";
                validate_new = true;
              }
              if (MainARR2[k].invPayDate == "") {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayDate_err"] =
                  "Payment Date Field is Required";
                validate_new = false;
                ++errCount2;
                break;
              } else {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayDate_err"] =
                  "";
                validate_new = true;
              }

              if (
                MainARR2[k].invPayStatus == "" ||
                MainARR2[k].invPayStatus == "0"
              ) {
                this.lineInvModalArray[j].invCurrencyList[k][
                  "invPayStatus_err"
                ] = "Payment Status Field is Required";
                validate_new = false;
                ++errCount2;
                break;
              } else {
                this.lineInvModalArray[j].invCurrencyList[k][
                  "invPayStatus_err"
                ] = "";
                validate_new = true;
              }
            }
          }
        }
      }

      if (errCount > 0 || errCount2 > 0 || errCount1 > 0) {
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
      // if (validate_new == false) {
      //   this.validateSB = false;
      // } else {
      //   this.validateSB = true;
      // }
    },
    async addSBDetail() {
      if (this.SBDetail.SlinePayId == "") {
        let checkValueExit = await this.checkInvNo();
        console.log("checkValueExit", checkValueExit);

        if (!checkValueExit) {
          this.alert.content =
            "Payment request for one or more invoices has already been raised to Accounts. Kindly check.";
          this.$refs["addPop"].open();
          return false;
        }
      }
      this.validateSBDetail();
      //  alert(this.validateSB);
      if (this.validateSB == false) {
        this.alert.content = "PLEASE ENTER ALL DETAILS.";
        this.$refs["addPop"].open();
        return false;
      }
      this.SBDetail["ccImportSeries"] =
        this.ImportDetail.ccImportSeries.replaceAll("/", "_");

      if (
        !this.SBDetail.slineInvoice ||
        (!this.SBDetail.blDraftUpload && this.SBDetail.SlinePayId == "")
      ) {
        console.log(
          this.SBDetail.slineInvoice +
          " : " +
          this.SBDetail.blDraftUpload +
          " : " +
          this.SBDetail.SlinePayId
        );
        this.alert.content = "Please Upload Shipping Line Invoice and BL Draft";
        this.$refs["addPop"].open();
        return false;
      }
      this.SBDetail["uploadArray"] = [];
      if (this.SBDetail.slineInvoice) {
        // Added By Priyanshu Singh Start

        if (this.SBDetail.SlinePayId == "") {
          let i = 0;
          this.lineInvModalArray.forEach((element) => {
            let obj = {
              allModuleId: this.ImportDetail.allModuleId,
              docName:
                "CC_IMP_SLine_Invoice-" +
                this.$sessionsStorage.get("editCcImportId") +
                "_" +
                i,
              docLink: element["invSlineUpload"],
            };
            this.SBDetail.uploadArray.push(obj);
            i++;
          });
        } else if (this.SBDetail.SlinePayId != "") {
          let i = 0;
          this.lineInvModalArray.forEach((element) => {
            if (this.SBDetail.revisedMail != "1") {
              if (element.SlineInvCategory == "Supplementary") {
                let obj = {
                  allModuleId: this.ImportDetail.allModuleId,
                  docName:
                    "suplimentrySlineInvoive_-" +
                    this.$sessionsStorage.get("editCcImportId") +
                    "_" +
                    i,
                  docLink: element["invSlineUpload"],
                };
                this.SBDetail.uploadArray.push(obj);
              } else if (element.SlineInvCategory == "Normal") {
                let obj = {
                  allModuleId: this.ImportDetail.allModuleId,
                  docName:
                    "CC_IMP_SLine_Invoice-" +
                    this.$sessionsStorage.get("editCcImportId") +
                    "_" +
                    i,
                  docLink: element["invSlineUpload"],
                };
                this.SBDetail.uploadArray.push(obj);
              }
            } else {
              let obj = {
                allModuleId: this.ImportDetail.allModuleId,
                docName:
                  "CC_IMP_SLine_Invoice-" +
                  this.$sessionsStorage.get("editCcImportId") +
                  "_" +
                  i,
                docLink: element["invSlineUpload"],
              };
              this.SBDetail.uploadArray.push(obj);
            }
            i++;
          });
        }
        // Added By Priyanshu Singh End
      }
      if (this.SBDetail.blDraftUpload) {
        if (this.SBDetail.SlinePayId == "") {
          let obj1 = {
            allModuleId: this.ImportDetail.allModuleId,
            docName:
              "CC_IMP_BL_DRAFT-" + this.$sessionsStorage.get("editCcImportId"),
            docLink: this.SBDetail.blDraftUpload,
          };
          this.SBDetail.uploadArray.push(obj1);
        } else if (this.SBDetail.SlinePayId != "") {
          let Category = "";
          this.lineInvModalArray.forEach((element) => {
            Category = element.SlineInvCategory;
          });
          if (this.SBDetail.revisedMail != "1") {
            if (Category == "Supplementary") {
              let obj1 = {
                allModuleId: this.ImportDetail.allModuleId,
                docName:
                  "suplimentrySlineBLDraft_-" +
                  this.$sessionsStorage.get("editCcImportId"),
                docLink: this.SBDetail.blDraftUpload,
              };
              this.SBDetail.uploadArray.push(obj1);
            } else if (Category == "Normal") {
              let obj1 = {
                allModuleId: this.ImportDetail.allModuleId,
                docName:
                  "CC_IMP_BL_DRAFT-" +
                  this.$sessionsStorage.get("editCcImportId"),
                docLink: this.SBDetail.blDraftUpload,
              };
              this.SBDetail.uploadArray.push(obj1);
            }
          } else {
            let obj1 = {
              allModuleId: this.ImportDetail.allModuleId,
              docName:
                "CC_IMP_BL_DRAFT-" +
                this.$sessionsStorage.get("editCcImportId"),
              docLink: this.SBDetail.blDraftUpload,
            };
            this.SBDetail.uploadArray.push(obj1);
          }
        }
      }

      this.SBDetail["stuffingType"] = this.WarehouseStuffing.stuffingType;
      this.SBDetail["ccExportId"] = this.$sessionsStorage.get("editCcImportId");
      // this.SBDetail["CCExecutionId"] = "0";// original previous
      this.SBDetail["CCExecutionId"] =
        this.$sessionsStorage.get("editCCExecutionId"); // Added Extra Priyanshu Singh
      this.SBDetail.clientName = this.ImportDetail.clientName;
      this.SBDetail.sline = this.ImportDetail.shippingLine;
      this.SBDetail.POR = this.ImportDetail.POR;
      this.SBDetail.salesExeuctionNo = this.ImportDetail.ccImportSeries;
      this.SBDetail.moduleType = "CC Import";
      this.SBDetail["Accounts"] = globalPermissionStatus("Accounts");
      this.SBDetail["role"] = this.role;

      this.SBDetail.invoiceDetails = this.lineInvModalArray;

      if (this.revisedInvoiceDetails.length > 0) {
        this.SBDetail.revisedInvoiceDetails = this.revisedInvoiceDetails;
      }
      // this.SBDetail.totalAmount = currItm.invPaidAmount;
      // this.SBDetail.paymentMode = currItm.invPayMode;
      console.log("After => ", this.SBDetail);
      //   return false
      this.validateSBDetail();
      console.log("Validation => ", this.validateSB);
      // this.validateSB = false;
      if (this.validateSB != false) {
        this.addSBDetail_button = true;
        $("#addButtonLoaderSB").css("display", "none");
        $("#loaderSB").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_SlineBillingCCExport/addCCImportSLinePayment_multi.php`,
          data: JSON.stringify(this.SBDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#loaderSB").css("display", "none");
              $("#addButtonLoaderSB").css("display", "block");
              this.addSBDetail_button = false;
              window.history.go(-1);
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
            }
          })
          .catch((error) => { });
      }
    },

    containerNoRegexfun() {
      this.showAlgo = true;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;
      // let lastDigitReturn = this.validContainerNo.slice(
      //   this.validContainerNo.length - 7
      // );
      // let lastDigitCon = this.ContainerTypeSizefactory.containerNo.slice(
      //   this.ContainerTypeSizefactory.containerNo.length - 7
      // );
      let containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      let arrayLen = [];
      if (this.ContainerTypeSizefactory.ccExecutionContainerId == "") {
        arrayLen = this.containerTypeDetailFactoryList.filter((x) => {
          return x.containerNo == this.ContainerTypeSizefactory.containerNo;
        });
      }

      if (
        arrayLen.length > 0 &&
        this.ContainerTypeSizefactory.ccExecutionContainerId == ""
      ) {
        this.containerNoRegexError = "Already Exist";
      } else if (
        containerformat.test(this.ContainerTypeSizefactory.containerNo)
      ) {
        this.containerNoRegexError = "";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
      }
    },

    getFFSlinePaymentData(mainEnquiryId) {

      this.doLoading();
      this.FFSeaExportArr = [];

      let payload = {
        itemCode: "getFFSlinePaymentList",
        mainEnquiryId: mainEnquiryId
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getDataCheck.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          console.log("hello salil", data);

          if (status == 200 && data) {

            if (data.FFSeaExportList.length > 0) {
              this.FFSeaExportArr = data.FFSeaExportList;
            }
          } else {
            this.FFSeaExportArr = [];
          }
          this.doLoadingClose();
        })

        .catch((error) => {
          console.log("Catch on FFSline Payment Data Error: ", error);
        });
    },

    getData() {
      this.doLoading();
      if (this.sbDetailArrayList.length == 1) {
        this.sbDetailArray = [];
      }
      if (this.containerTypeDetailFactory.length == 1) {
        this.containerTypeDetailFactory = [];
      }
      if (this.getContainerList.length == 1) {
        this.getContainerList = [];
      }
      let new_data = {
        ccExportId: this.$sessionsStorage.get("editCcImportId"),
        allModuleId: this.$sessionsStorage.get("allModuleId"),
        TYPE: this.$sessionsStorage.get("TYPE"),
        JOBSERIES: this.$sessionsStorage.get("JOBSERIES"),
        EXPORTER: this.$sessionsStorage.get("EXPORTER"),
      };
      //   console.log(new_data);
      //   return false;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_SlineBillingCCExport/viewccimpslinePaymentDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            console.log("MyDataArr=>", data);
            // alert(this.$sessionsStorage.get("editCCExecutionId"));
            console.log("Priyanshu Singh=>", data.editCCEX);
            if (data.ContainerFromTPT.length > 0) {
              if (!this.$sessionsStorage.get("editCCExecutionId")) {
                this.$sessionsStorage.set(
                  "editCCExecutionId",
                  data.autoExecutionId
                );
              }
              this.ContainerFromTPT = data.ContainerFromTPT;

              if (data.ContainerFromTPT[0].ContainerNumber != null) {
                this.ContainerNoTPT =
                  data.ContainerFromTPT[0].ContainerNumber.split(",");
              }
              if (data.ContainerFromTPT[0].ContainerType.length > 0) {
                this.ContainerNoTypeTPT =
                  data.ContainerFromTPT[0].ContainerType.split(",");
              }
              this.conDetailsTPT =
                data.ContainerFromTPT[0].ContainerType +
                "\n" +
                data.ContainerFromTPT[0].ContainerNumber;
            }

            this.getLocationList = data.portLocationArray;

            if (data.containerCountWise.length > 0) {
              this.containerCountWise = data.containerCountWise;
              let array_new = this.containerCountWise.map((x) => {
                if (x.totalCount == 0) {
                  this.showDivCountNote = false;
                } else {
                  this.showDivCountNote = true;
                  return false;
                }
              });
            }

            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }

            if (data.containerMaster.length > 0) {
              this.getContainerList = data.containerMaster;
            }

            if (data.mainSalesData.length > 0) {
              this.getFFSlinePaymentData(data.mainSalesData[0].mainEnquiryId);
            }

            if (data.ffBookingDetail.length > 0) {
              Object.keys(data.ffBookingDetail[0]).map((x) => {
                this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
              });
            }
            console.log("Priyanshu Singh=>", data);
            if (data.editCCEX.length > 0) {
              this.WarehouseStuffing.portType = data.editCCEX[0].portType;
              this.SBDetail.allModuleId = data.editCCEX[0].allModuleId;
              this.POR = data.editCCEX[0].POR;

              this.WarehouseStuffing.stuffingType =
                data.editCCEX[0].stuffingType;

              this.WarehouseStuffing.containerInfo =
                data.editCCEX[0].containerInfo;
              Object.keys(data.editCCEX[0]).map((x) => {
                this.ImportDetail[x] = data.editCCEX[0][x] || "";
              });
            }

            if (data.ffBookingTranshipment.length > 0) {
              this.tentativeDetailArray = data.ffBookingTranshipment;
            }
            // alert(this.$sessionsStorage.get("editCCExecutionId"));
            if (
              this.$sessionsStorage.get("editCCExecutionId") != "" &&
              this.$sessionsStorage.get("editCCExecutionId") != undefined
            ) {
              this.viewExecutionDetail();
            } else {
              this.doLoadingClose();
            }
            // this.JqueryFun();
          }
        })
        .catch((error) => { });
    },
    viewExecutionDetail() {
      this.doLoading();
      // alert("psing");
      // this.doLoadingClose();
      let new_data = {
        ccExportId: this.$sessionsStorage.get("editCcImportId"),
        ccExecutionId: this.$sessionsStorage.get("editCCExecutionId"),
        newData: this.ImportDetail,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_SlineBillingCCExport/viewCCimportExecutionDetailsMulti.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      console.log("Execution");

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            console.log("count => ", data.ccSLinePayDetail.length);
            if (data.ccSLinePayDetail.length > 0) {
              Object.keys(this.SBDetail).map((x) => {
                this.SBDetail[x] = data.ccSLinePayDetail[0][x] || "";
              });
              console.log("data.SBDetail=>", this.SBDetail);
              Object.keys(this.lineInvModalArray).map((x) => {
                this.lineInvModalArray[x] = data.ccSLinePayDetail[0][x] || "";
              });
              // console.log("data.ccSLinePayDetail=>",data.ccSLinePayDetail);
              data.ccSLinePayDetail.forEach((element) => {
                console.log("Element => ", element);

                let amount = element["invoiceAmount"].split(",");
                let currency = element["invoiceCurrency"].split(",");

                element["invNo"] = element.SlineInvNo;
                element["inv_date"] = element.inv_date;
                element["invType"] = element.SlineInvType;
                element["invCategory"] = element.SlineInvCategory;
                element["scCategory"] = element.scCategory;
                element["scremark"] = element.scremark;
                element["dispute_status"] = element.dispute_status || "";
                element["sline_dispute"] = element.sline_dispute || "";
                element["resolved_amount"] = element.resolved_amount || "";
                console.log(element["invNo"] + " : " + element["invType"]);

                let invCurrencyList = [];

                for (let i = 0; i < amount.length; i++) {
                  invCurrencyList.push({
                    invAmount: amount[i],
                    invCurrency: currency[i],
                  });
                }

                element["invCurrencyList"] = invCurrencyList;

                //this.lineInvModalArray.push(element)
              });
              console.log("ccSLinePayInvoices", data.ccSLinePayInvoices);
              console.log("INVDoc", data.INVDoc);
              console.log("data.ccSLinePayInvoices=>", data.ccSLinePayInvoices);
              data.ccSLinePayInvoices.forEach((element) => {
                element["invNo"] = element.SlineInvNo;
                element["inv_date"] = element.inv_date;
                // element['invType'] =element.SlineInvType
                element["invType"] = JSON.parse(element.SlineInvType);
                element["invCategory"] = element.SlineInvCategory;
                element["scCategory"] = element.scCategory;
                element["scremark"] = element.scremark;
                element["dispute_status"] = element.dispute_status || "";
                element["sline_dispute"] = element.sline_dispute || "";
                element["resolved_amount"] = element.resolved_amount || "";
                this.items = JSON.parse(element.SlineInvType);

                let invoiceAmount = data.ccSLinePayAmount.filter((amoIndex) => {
                  return amoIndex.SlineInvId == element.SlineInvId;
                });

                let invCurrencyList = [];

                for (let i = 0; i < invoiceAmount.length; i++) {
                  let date = new Date(invoiceAmount[i].SlineInvPayDate);
                  let result =
                    "" +
                    date.getFullYear() +
                    (date.getMonth() + 1 > 9 ? "-" : "-0") +
                    (date.getMonth() + 1) +
                    (date.getDate() > 9 ? "-" : "-0") +
                    date.getDate();
                  // alert(result);
                  let SlineInvPayDate = "";
                  if (result == "1970-01-01") {
                    SlineInvPayDate = "";
                  } else {
                    SlineInvPayDate = result;
                  }
                  invCurrencyList.push({
                    ccSlineInvAmoId: invoiceAmount[i].SlineInvAmoId,
                    invNo: invoiceAmount[i].SlineInvNo || "",
                    inv_date: invoiceAmount[i].inv_date || "",
                    invId: invoiceAmount[i].SlineInvId || "",
                    invPayId: invoiceAmount[i].SlinePayId || "",
                    invAmount: invoiceAmount[i].SlineInvAmount || "",
                    invCurrency: invoiceAmount[i].SlineInvCurrency || "",
                    invPayMode: invoiceAmount[i].SlineInvPayMode || "",
                    invPayRef: invoiceAmount[i].SlineInvPayRef || "",
                    invPaidAmount: invoiceAmount[i].SlineInvPaidAmount || "",
                    invPayDate: SlineInvPayDate || "",
                    invPayStatus: invoiceAmount[i].SlineInvPayStatus || "",
                  });
                }

                element["invCurrencyList"] = invCurrencyList;
                this.lineInvModalArray.push(element);
              });

              // Priyanshu Singh Code Start

              let arr1 = data.INVDoc;
              const enptyarr = [];
              let arr2 = this.lineInvModalArray;
              console.log("INVDoc_query=>", data.INVDoc_query);
              console.log("arr1=>", arr1);
              console.log("arr2=>", arr2);

              // debugger;
              let result = [];
              arr1.forEach((ar, arr1index) => {
                result[arr1index] = Object.assign(
                  {},
                  arr1[arr1index],
                  arr2[arr1index]
                );
              });
              console.log("result=>", result);
              this.lineInvModalArray = [];
              this.$forceUpdate();
              result.forEach((element) => {
                if (element.SlineInvId != "") element["enableDisable"] = true;
                // alert( element.doc_id);
                element["doc_id"] = element.doc_id;
                element["documentName"] = element.documentName;
                element["documentLink"] = element.documentLink;
                element["docRemarks"] = element.docRemarks;
                element["isDocActive"] = element.isDocActive;
                element["otherDocName"] = element.otherDocName;
                element["docAddedDate"] = element.docAddedDate;
                element["invNo"] = element.SlineInvNo;
                element["inv_date"] = element.inv_date;
                element["invType"] = JSON.parse(element.SlineInvType);
                element["invCategory"] = element.SlineInvCategory;
                element["scCategory"] = element.scCategory;
                element["scremark"] = element.scremark;
                element["dispute_status"] = element.dispute_status || "";
                element["sline_dispute"] = element.sline_dispute || "";
                element["resolved_amount"] = element.resolved_amount || "";
                this.items = JSON.parse(element.SlineInvType);
                console.log("element=>", element);
                let invoiceAmount = data.ccSLinePayAmount.filter((amoIndex) => {
                  return amoIndex.SlineInvId == element.SlineInvId;
                });

                let invCurrencyList = [];

                for (let i = 0; i < invoiceAmount.length; i++) {
                  let date = new Date(invoiceAmount[i].SlineInvPayDate);
                  let result =
                    "" +
                    date.getFullYear() +
                    (date.getMonth() + 1 > 9 ? "-" : "-0") +
                    (date.getMonth() + 1) +
                    (date.getDate() > 9 ? "-" : "-0") +
                    date.getDate();
                  // alert(result);
                  let SlineInvPayDate = "";
                  if (result == "1970-01-01") {
                    SlineInvPayDate = "";
                  } else {
                    SlineInvPayDate = result;
                  }
                  // alert(SlineInvPayDate);
                  invCurrencyList.push({
                    SlineInvAmoId: invoiceAmount[i].SlineInvAmoId,
                    invNo: invoiceAmount[i].SlineInvNo || "",
                    inv_date: invoiceAmount[i].inv_date || "",
                    invId: invoiceAmount[i].SlineInvId || "",
                    invPayId: invoiceAmount[i].SlinePayId || "",
                    invAmount: invoiceAmount[i].SlineInvAmount || "",
                    invCurrency: invoiceAmount[i].SlineInvCurrency || "",
                    invPayMode: invoiceAmount[i].SlineInvPayMode || "",
                    invPayRef: invoiceAmount[i].SlineInvPayRef || "",
                    invPaidAmount: invoiceAmount[i].SlineInvPaidAmount || "",
                    invPayDate: SlineInvPayDate || "",
                    invPayStatus: invoiceAmount[i].SlineInvPayStatus || "",
                  });
                }
                element["invCurrencyList"] = invCurrencyList;

                this.lineInvModalArray.push(element);
              });
              this.$forceUpdate();
              console.log(
                "this.NWQlineInvModalArray=>",
                this.lineInvModalArray
              );
              if (result.length > 0) {
                this.disableSaveSubmit = true;
              }

              if (this.accounts == true || this.role == "Admin") {
                this.disableSaveSubmit = false;
              }
              console.log("NewlineInvModalArray", this.lineInvModalArray);
              console.log("SBDetails new => ", this.lineInvModalArray);

              // Priyanshu Singh Code End
            }

            console.log("SBDetails new => ", this.lineInvModalArray);
            if (data.ccExecutionDetail.length > 0) {
              Object.keys(this.WarehouseStuffing).map((x) => {
                this.WarehouseStuffing[x] = data.ccExecutionDetail[0][x] || "";
              });
            }
            console.log("Happy Singh=>", data.ccExecutionDetailContainer);
            if (data.ccExecutionDetailContainer.length > 0) {
              if (this.ContainerFromTPT.length > 0) {
                let dummyContainer = [];
                for (
                  let i = 0;
                  i < data.ccExecutionDetailContainer.length;
                  i++
                ) {
                  let obj = {
                    ccExecutionContainerId:
                      data.ccExecutionDetailContainer[i].ccExecutionContainerId,
                    containerTypeId:
                      data.ccExecutionDetailContainer[i].containerTypeId,
                    containerType:
                      data.ccExecutionDetailContainer[i].containerType,
                    LineSealNo: data.ccExecutionDetailContainer[i].LineSealNo,
                    PickupLocation:
                      data.ccExecutionDetailContainer[i].PickupLocation,
                    StuffingLocation:
                      data.ccExecutionDetailContainer[i].StuffingLocation,
                    cargoStuffingDate:
                      data.ccExecutionDetailContainer[i].cargoStuffingDate,
                    cargoWeight: data.ccExecutionDetailContainer[i].cargoWeight,
                    containerInfo:
                      data.ccExecutionDetailContainer[i].containerInfo,
                    containerWithSplit:
                      data.ccExecutionDetailContainer[i].containerWithSplit,
                    customSealNo:
                      data.ccExecutionDetailContainer[i].customSealNo,
                    CCExecutionId:
                      data.ccExecutionDetailContainer[i].CCExecutionId,
                    ccImportId: data.ccExecutionDetailContainer[i].ccExportId,
                    grossWeight: data.ccExecutionDetailContainer[i].grossWeight,
                    handoverDate:
                      data.ccExecutionDetailContainer[i].handoverDate,
                    leeoDate: data.ccExecutionDetailContainer[i].leeoDate,
                    leeoNo: data.ccExecutionDetailContainer[i].leeoNo,
                    measurement: data.ccExecutionDetailContainer[i].measurement,
                    netWeight: data.ccExecutionDetailContainer[i].netWeight,
                    noOfpkgUnit: data.ccExecutionDetailContainer[i].noOfpkgUnit,
                    packageId: data.ccExecutionDetailContainer[i].packageId,
                    pickupDate: data.ccExecutionDetailContainer[i].pickupDate,
                    portType: data.ccExecutionDetailContainer[i].portType,
                    stuffingDate:
                      data.ccExecutionDetailContainer[i].stuffingDate,
                    tareWeight: data.ccExecutionDetailContainer[i].tareWeight,
                    weightUnit: data.ccExecutionDetailContainer[i].weightUnit,
                    containerNo:
                      data.ccExecutionDetailContainer[i].containerNo == ""
                        ? this.ContainerNoTPT[i]
                        : data.ccExecutionDetailContainer[i].containerNo,
                  };
                  dummyContainer.push(obj);
                }
                this.containerTypeDetailFactory = dummyContainer;
              } else {
                this.containerTypeDetailFactory =
                  data.ccExecutionDetailContainer;
              }

              Object.keys(this.ContainerTypeSizefactory).map((x) => {
                this.ContainerTypeSizefactory[x] =
                  data.ccExecutionDetailContainer[0][x] || "";
              });

              Object.keys(this.removeContainerVmodel).map((x) => {
                this.ContainerTypeSizefactory[x] = "";
              });
            }

            if (data.ccSBDetail.length > 0) {
              this.sbDetailArray = data.ccSBDetail;
            }
            if (data.suplimentaryInvData.length > 0) {
              this.suplimentaryInvData = data.suplimentaryInvData;
            }
            const user_data = {
              userId: this.ImportDetail.userId,
            };
            let options = {
              method: "POST",
              url: `${URL_BASE}/getUser.php`,
              data: JSON.stringify(user_data),
              crossDomain: true,

              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: this.$sessionsStorage.get("loginId"),
              },
            };

            axios(options).then((result2) => {
              const { statusText, status, data } = result2;
              console.log(data);
              if (data.user) {
                console.log(data);
                this.ImportDetail.username = data.user[0].employeeName;
              }
            });

            this.doLoadingClose();
          }
        })
        .catch((error) => { });
    },
    chnageSCCategoryList(
      scCategory,
      scCategory_err,
      scremark,
      scremark_err,
      lineInvModalArray,
      idx
    ) {
      this.lineInvModalArray[idx].scCategory_err = "";
      this.lineInvModalArray[idx].scremark_err = "";
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ccContainer").DataTable();
    //   });
    // }
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ccSLinePaymentImportN.vue?2c2044ae